<template>
    <div class="md-quick-search broker" v-if="filteredList.length > 0">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="mg-title" v-if="selectedQuickSearch.title" v-html="formatFontSize(selectedQuickSearch.title, '--mg-title-size')"></div>
            <div class="list">
                <ul :class="{ 'quick-list': true, collapse: collapse }">
                    <li
                        v-for="item in filteredList"
                        :key="item.id"
                        class="quick-search-item"
                        :class="{ hot: item.hot }"
                    >
                        <a
                            v-if="item.type != 'link'"
                            :href="item.href"
                            :title="item.title"
                            rel="noopener noreferrer"
                        >
                            <span class="search-title">{{ item.title }}</span>
                            <span class="hot-search" v-if="item.hot">{{
                                $t('md-quick-search.hot')
                            }}</span>
                            <Count
                                :max="mlsCount"
                                :count="
                                    countMap[item.key] === undefined
                                        ? -1
                                        : countMap[item.key]
                                "
                            />
                        </a>
                        <a
                            v-else
                            :href="item.url"
                            :title="item.title"
                            rel="noopener noreferrer"
                        >
                            <span class="search-title">{{ item.title }}</span>
                            <span v-if="item.hot" class="hot-search">{{
                                $t('md-quick-search.hot')
                            }}</span>
                        </a>
                    </li>
                </ul>
                <span
                    v-if="showmore"
                    class="quicksearch-more"
                    @click="toggleShowMore"
                >{{
                    $t('md-quick-search.thereAreQuickSearches', {
                        count: filteredList.length
                    })
                }}</span
                >
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
export default {
    ...common
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-quick-search.broker {
    .mg-title {
        color: #191919;
        font: 24px var(--mg-title-font);
    }
    .list {
        overflow: hidden;
        .quick-list {
            width: 100%;
            overflow: hidden;
            margin-top: 0;
            display: flex;
            flex-wrap: wrap;
            margin-top: -15px;
            li {
                overflow: hidden;
                position: relative;
                width: calc((100% - 40px) / 3);

                background-color: #f3f3f3;
                border-radius: 5px;
                margin-top: 15px;
                border: 1px solid #f3f3f3;
                &:hover {
                    background: #fff;
                    border: 1px solid var(--color-theme);
                    box-shadow: 0 8px 20px 0 rgba(0, 10, 30, 0.05);
                }
                a {
                    padding: 11px 20px;
                    display: flex;
                    flex-wrap: nowrap;
                    align-items: center;
                    .search-title {
                        font-size: 14px;
                        line-height: 16px;
                        text-align: left;
                        @include ellipsis();
                        color: #191919;
                    }
                    .hot-search {
                        flex: none;
                        margin-left: 10px;
                        font-size: 12px;
                        font-family: var(--font-bold);
                        line-height: 16px;
                        width: 40px;
                        text-align: center;
                        border-radius: 7px 7px 7px 2px;
                        background-color: #fb6f67;
                        color: #fff;
                    }
                    .num {
                        flex: 1;
                        padding-left: 8px;
                        text-align: right;
                        color: #505050;
                        font-size: 14px;
                        line-height: 16px;
                    }
                }
                &:nth-child(3n-1),
                &:nth-child(3n-2) {
                    margin-right: 20px;
                }
            }
        }
        .quicksearch-more {
            display: none;
        }
    }

    @include media-1080 {
        .list {
            .quick-list {
                justify-content: space-between;
                li {
                    width: calc(50% - 10px);
                    &:nth-child(3n-1),
                    &:nth-child(3n-2) {
                        margin-right: 0;
                    }
                }
            }
        }
    }

    @include media-600 {
        .mg-title {
            font-size: 16px;
        }
        .list {
            .quick-list {
                margin-top: 0;
                margin-bottom: 0;
                li {
                    width: 100%;
                    display: block;
                    // padding: 12px 15px;
                    &:first-child {
                        margin-top: 0;
                    }
                    .num {
                        font-size: 14px;
                    }
                }
                &.collapse {
                    overflow: hidden;
                    li {
                        display: none;
                        &:nth-child(-n + 5) {
                            display: block;
                        }
                    }
                }
            }
            .quicksearch-more {
                display: block;
                text-decoration: underline;
                @include color-theme();
                text-align: center;
                cursor: pointer;
                margin-top: 15px;
                font-size: 14px;
                font-family: var(--font-normal);
                line-height: 16px;
            }
        }
    }
}
.md-search-result.broker .md-quick-search.broker {
    .list {
        .quick-list {
            li {
                width: calc(50% - 10px);
            }
        }
    }
}
</style>
